"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalNames = exports.SectionDeleteModal = exports.TherapyNoteDeleteModal = exports.UserDeleteModal = exports.ProgramDeleteModal = void 0;
const program_delete_modal_1 = __importDefault(require("./program-delete-modal"));
exports.ProgramDeleteModal = program_delete_modal_1.default;
const section_delete_modal_1 = __importDefault(require("./section-delete-modal"));
exports.SectionDeleteModal = section_delete_modal_1.default;
const therapy_note_delete_modal_1 = __importDefault(require("./therapy-note-delete-modal"));
exports.TherapyNoteDeleteModal = therapy_note_delete_modal_1.default;
const user_delete_modal_1 = __importDefault(require("./user-delete-modal"));
exports.UserDeleteModal = user_delete_modal_1.default;
const ModalNames = {
    USER_DELETE: 'USER_DELETE',
    THERAPY_NOTE_DELETE: 'THERAPY_NOTE_DELETE',
    PROGRAM_DELETE: 'PROGRAM_DELETE',
    SECTION_DELETE: 'SECTION_DELETE'
};
exports.ModalNames = ModalNames;
